export const DOG_API = 'https://dog.ceo/api';
